import {MonitorType} from "areas/assets/monitors/monitorType";
import {createModelSchemaWrapper} from "framework/serializr-integration";
import {primitive} from "serializr";
import {makeAutoObservable} from "mobx";

export class AssetHealthMonitor {
	dataUnavailable: boolean
	healthIndex: number
	id: string
	monitorError: boolean
	monitorMaintenance: boolean
	monitorType: MonitorType
	name: string
	type: MonitorType

	constructor() {
		makeAutoObservable(this)
	}
}

createModelSchemaWrapper(AssetHealthMonitor, {
	dataUnavailable: primitive(),
	healthIndex: primitive(),
	id: primitive(),
	monitorError: primitive(),
	monitorMaintenance: primitive(),
	monitorType: primitive(),
	name: primitive(),
	type: primitive(),
})
